module.exports = __webpack_public_path__ + "img/mastercard.1483ca30.png";